"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Conversation/Message/FileMessage/FileImage/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _message = require('shared/enum/message');
var _Modal = require('web/components/Modal'); var _Modal2 = _interopRequireDefault(_Modal);
var _DerivativeImage = require('../DerivativeImage'); var _DerivativeImage2 = _interopRequireDefault(_DerivativeImage);
var _ModalView = require('./ModalView'); var _ModalView2 = _interopRequireDefault(_ModalView);
var _keyboard = require('web/services/keyboard');


















const FileImage = ({
  fileName,
  thumbnailUrl,
  blurHash,
  imageWidth,
  imageHeight,
  deliveryStatus,
  onRequestFreshThumbnail,
  onRequestOriginal,
  onDownloadOriginal,
  onAbort,
  onRetry,
  canRetry = true,
}) => {
  const [showingLightbox, setShowingLightbox] = _react.useState.call(void 0, false)
  const [originalUrl, setOriginalUrl] = _react.useState(null)
  const [originalUnavailable, setOriginalUnavailable] = _react.useState.call(void 0, false)
  const closeLightBox = () => {
    setShowingLightbox(false)
    setOriginalUnavailable(false)
  }
  const openLightBox = () => {
    setShowingLightbox(true)
    if (!originalUrl && !originalUnavailable) {
      onRequestOriginal()
        .then(url => {
          setOriginalUrl(url)
          setOriginalUnavailable(!url)
        })
        .catch(() => setOriginalUnavailable(true))
    }
  }

  const isLoading = deliveryStatus === _message.deliveryStatus.SENT
  const hasFailed = deliveryStatus === _message.deliveryStatus.FAILED
  const [overlayClassName, controlsClassName] = _react.useMemo.call(void 0, 
    () => [
      _classBuilder2.default.call(void 0, 
        'file-message--image--overlay',
        (isLoading || hasFailed) && 'file-message--image--overlay-blurred',
      ),
      _classBuilder2.default.call(void 0, 
        'file-message--image--controls',
        (isLoading || hasFailed) && 'file-message--image--controls-active',
      ),
    ],
    [isLoading, hasFailed],
  )

  const modalGateway = window.location === window.parent.location
    ? _react2.default.createElement(_Modal2.default, {
        isOpen: showingLightbox,
        fullScreen: !originalUnavailable,
        onClose: closeLightBox,
        className: originalUnavailable ? undefined : 'file-image--preview-modal',
        bodyClassName: originalUnavailable ? undefined : 'file-image--preview-modal--body',
        size: originalUnavailable ? 'xs' : undefined,
        title: originalUnavailable ? 'Unable to open image' : undefined, __self: this, __source: {fileName: _jsxFileName, lineNumber: 77}}

        , originalUrl
          ? _react2.default.createElement(_ModalView2.default, {
              imageSrc: originalUrl,
              imageCaption: fileName,
              onClose: closeLightBox,
              onDownload: _nullishCoalesce(onDownloadOriginal, () => ( (() => window.open(originalUrl)))), __self: this, __source: {fileName: _jsxFileName, lineNumber: 87}}
            )
          : originalUnavailable
            ? _react2.default.createElement(_react2.default.Fragment, null
                , _react2.default.createElement(_Modal.ModalDesc, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 95}}, "We could not open this image. Please try again."        )
                , _react2.default.createElement(_Modal.ModalControls, {
                  primaryBtnLabel: "Close",
                  onPrimaryBtnClick: closeLightBox, __self: this, __source: {fileName: _jsxFileName, lineNumber: 96}}
                )
              )
            : null
      )
    : null

  return (
    _react2.default.createElement(_react2.default.Fragment, null
      , modalGateway
      , _react2.default.createElement(_DerivativeImage2.default, {
        blurHash: blurHash,
        thumbnailUrl: thumbnailUrl,
        width: imageWidth,
        height: imageHeight,
        fileName: fileName,
        onRequestFreshThumbnail: onRequestFreshThumbnail,
        onOpenOriginal: openLightBox, __self: this, __source: {fileName: _jsxFileName, lineNumber: 108}}

        , _react2.default.createElement('div', { className: overlayClassName, __self: this, __source: {fileName: _jsxFileName, lineNumber: 117}} )
        , isLoading && _react2.default.createElement('div', {
          onClick: event => { event.stopPropagation(); onAbort() },
          role: "button", tabIndex: 0, onKeyDown: _keyboard.onButtonKeyDown,
          className: controlsClassName, __self: this, __source: {fileName: _jsxFileName, lineNumber: 118}}
, _react2.default.createElement('div', { className: "file-message--btn file-message--btn-loading" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 122}} ))
        , hasFailed && canRetry && _react2.default.createElement('div', {
          onClick: event => { event.stopPropagation(); onRetry() },
          role: "button", tabIndex: 0, onKeyDown: _keyboard.onButtonKeyDown,
          className: controlsClassName, __self: this, __source: {fileName: _jsxFileName, lineNumber: 123}}
, _react2.default.createElement('div', { className: "file-message--btn file-message--btn-retry" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 127}} ))
      )
    )
  )
}

exports. default = FileImage
